<app-dialog-layout [showCloseButton]="true" [showFooter]="false" (closeDialogChange)="close()">
  <ng-container content>
    <p-splitter
      styleClass="panels"
      panelStyleClass="node-editor-panel"
      [panelSizes]="panelSize()"
      [minSizes]="[5, 30, 5]"
      [gutterSize]="6">
      <ng-template pTemplate>
        @if (node.nodeData.type !== nodeType.Trigger) {
          <app-panel-layout>
            <panel-title>
              {{ 'flow.node.input-panel.title' | translate }}
            </panel-title>

            <panel-body>
              @if (previousSteps().length) {
                <app-variable-picker-search
                  class="previous-steps-search"
                  [query]="variableFilter()"
                  [count]="totalMatches()"
                  [active]="!!variableFilter().trim()"
                  (queryChange)="variableFilter.set($event)"
                  (cleared)="variableFilter.set('')" />
              }

              @defer (when previousSteps().length) {
                <p-accordion [multiple]="true" styleClass="previous-steps" [value]="openStepIds()">
                  @for (entry of displaySteps(); track entry.step.id; let index = $index) {
                    @let step = entry.step;
                    <p-accordion-panel [value]="step.id" [disabled]="step.nodeData.type === nodeType.Trigger">
                      <p-accordion-header>
                        <div class="previous-step-header">
                          <div class="previous-step-header-icon">
                            <i [class]="step.nodeData.icon | nodeIcon"></i>
                          </div>

                          <label class="previous-step-header-label">
                            @if (step.nodeData.type === nodeType.HttpAction) {
                              {{ step.nodeData.data.application.name }} - {{ step.nodeData.name }}
                            } @else {
                              {{ step.nodeData.name }}
                            }
                          </label>

                          @if (variableFilter().trim()) {
                            <span class="previous-step-match">{{ entry.count }}</span>
                          }

                          @if (step.nodeData.type !== nodeType.Trigger) {
                            <!-- for now button is disabled, not supported by BE yet -->
                            <cap-button
                              styleClass="primary btn-xs"
                              [disabled]="true"
                              [label]="'flow.node.execute.label' | translate"
                              (click)="executePreviousStep(step, index, $event)" />
                          }
                        </div>
                      </p-accordion-header>

                      <p-accordion-content>
                        @if (step.nodeData.type !== nodeType.Trigger) {
                          @if (step.nodeData.type === nodeType.HttpAction) {
                            <app-variable-picker-tree
                              [data]="step.nodeData.stubs()"
                              [pathMap]="true"
                              [searchQuery]="variableFilter()"
                              [useValueKey]="node.nodeData.type === nodeType.Loop" />
                          } @else {
                            @defer (when step.nodeData.execution.result() && step.nodeData.execution.executed) {
                              <app-variable-picker-tree
                                [data]="step.nodeData.execution.result()"
                                [searchQuery]="variableFilter()" />
                            } @placeholder {
                              <label class="not-executed-message">{{
                                'flow.step-not-executed.label' | translate
                              }}</label>
                            } @loading (minimum 150ms) {
                              <app-loading />
                            }
                          }
                        }
                      </p-accordion-content>
                    </p-accordion-panel>
                  }
                </p-accordion>
              }
            </panel-body>
          </app-panel-layout>
        }
      </ng-template>
      <!-- Node configurator -->
      <ng-template pTemplate>
        <app-panel-layout>
          <panel-title>
            {{ 'flow.node.configuration-panel.title' | translate }}
          </panel-title>

          <panel-body>
            <ng-template
              #nodeEditorComponent
              [nodeEditorComponent]="node"
              (componentIsRendered)="componentIsRendered()" />
          </panel-body>

          <panel-footer>
            <div class="node-editor-buttons">
              <div class="node-editor-buttons-left">
                <!-- @Todo: not applicable for now, turn on when BE is ready -->
                @if (false) {
                  <cap-button
                    styleClass="secondary"
                    icon="mynaui-flask-conical"
                    [label]="'button.test-step' | translate"
                    (onClick)="testStep()" />
                }
              </div>

              <div class="node-editor-buttons-right">
                <cap-button
                  styleClass="primary"
                  [disabled]="buttonDisabled()"
                  [label]="'button.save' | translate"
                  (onClick)="save()" />
              </div>
            </div>
          </panel-footer>
        </app-panel-layout>
      </ng-template>
      <ng-template pTemplate>
        <app-panel-layout class="output-panel">
          <panel-title>
            {{ 'flow.node.output-panel.title' | translate }}
          </panel-title>

          <panel-body>
            @defer (when executionResult()) {
              @if (executionResult()) {
                <app-data-schema [data]="executionResult()" [level]="0" [panelType]="'output'" />
              }
            } @loading (minimum 150ms) {
              <app-loading />
            }
          </panel-body>
        </app-panel-layout>
      </ng-template>
    </p-splitter>
  </ng-container>
</app-dialog-layout>
